import React, { useEffect, useState, useRef } from "react";
import {
  createStyles,
  Grid,
  makeStyles,
  Button,
  Theme,
  Box,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Modal from "@material-ui/core/Modal";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import { useAppData } from "../../services/hooks";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";
import {
  getNewRequest_toolAction,
  getNewRequest_suppliersAction,
  submitDataAction,
  getNewRequest_itemsAction,
  getNewRequest_stateAction
} from "../toolDisposalSlice";
import moment from "moment";
import { toolSelectOptions } from "../../constants/toolConstant";
import { toast } from "react-toastify";

const partApi = ["53455575"];
// To be implemented using map
const modelYearMin_data = [
  { modelYearMin: "2004" },
  { modelYearMin: "2005" },
  { modelYearMin: "2006" },
  { modelYearMin: "2007" },
  { modelYearMin: "2008" },
  { modelYearMin: "2009" },
  { modelYearMin: "2010" },
  { modelYearMin: "2011" },
  { modelYearMin: "2012" },
  { modelYearMin: "2013" },
  { modelYearMin: "2014" },
  { modelYearMin: "2015" },
  { modelYearMin: "2016" },
  { modelYearMin: "2017" },
  { modelYearMin: "2018" },
  { modelYearMin: "2019" },
  { modelYearMin: "2020" },
  { modelYearMin: "2021" },
  { modelYearMin: "2022" },
  { modelYearMin: "2023" },
  { modelYearMin: "2024" },
  { modelYearMin: "2025" },
];

// To be implemented using map TODO
const modelYearMax_data = [
  { modelYearMax: "2004" },
  { modelYearMax: "2005" },
  { modelYearMax: "2006" },
  { modelYearMax: "2007" },
  { modelYearMax: "2008" },
  { modelYearMax: "2009" },
  { modelYearMax: "2010" },
  { modelYearMax: "2011" },
  { modelYearMax: "2012" },
  { modelYearMax: "2013" },
  { modelYearMax: "2014" },
  { modelYearMax: "2015" },
  { modelYearMax: "2016" },
  { modelYearMax: "2017" },
  { modelYearMax: "2018" },
  { modelYearMax: "2019" },
  { modelYearMax: "2020" },
  { modelYearMax: "2021" },
  { modelYearMax: "2022" },
  { modelYearMax: "2023" },
  { modelYearMax: "2024" },
  { modelYearMax: "2025" },
];

var modelYearMax: any = [];
for (var i = 2004; i < new Date().getFullYear() + 4; i++) {
  modelYearMax.push({
    modelYearMax: i,
  });
}

let newBindingData: any;
export const AddToolModel = ({
  onConfirmClick,
  disabled,
  paramsData,
  requester,
  openModal = false,
  onaHandleClose,

}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const toolValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.toolValue
  );
  const row = useAppData((r) => r.toolDisposalSlice.updateValues.value);
  console.log("rowwwww", row);
  const productLinese = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.productLinesValue
  );
  const toolsDetailFromStore = useAppData(
    (r) => r.toolDisposalSlice.updateValues.value.toolsDetails?.toolsDetail
  );

  const toolsDetailRows: any[] = Array.isArray(toolsDetailFromStore)
    ? toolsDetailFromStore
    : Array.isArray(row?.toolsDetails?.toolsDetail)
      ? row.toolsDetails.toolsDetail
      : [];
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  const statesValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.statesValue
  );
  const supplierValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.suppliersValue
  );
  const supplierNumberValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.suppliersNumberValue
  );
  const countriesValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.countriesValue
  );
  const toolTypesValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.toolTypesValue
  );
  const projectNumberValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.projectNumberValue
  );
  const validationStatus = useAppData((r) => r.global.validationStatus.isInvalid);
  const [bindingData, setBindingData] = useState({});
  const createTagHandler =
    (
      tagType:

        | "toolNumber"
        | "toolNumberWrite"
        | "handleToolDescriptionStatic"
        | "toolDescription"
        | "attachments"
        | "toolNumberStatic"
        | "supplierNumber"
        | "supplierName"
        | "toolTypeId"
        | "poNumber"
        | "productLines"
        | "modelYearMin"
        | "modelYearMax"
        | "countryToolResidesIn"
        | "totalPOValue"
        | "projectNumber"
        | "lastUsedDate"
        | "stateToolResidesIn"
    ) =>
      (value: any) => {
        const { ...rowdata } = row;
        if (tagType === "supplierName") {
          dispatch(
            submitDataAction({
              body: {
                ...rowdata,
                supplierName: value.supplierName,
                supplierNumber: value.supplierNumber,
              },
            })
          );
        } else if (tagType === "toolTypeId") {
          dispatch(
            submitDataAction({
              body: {
                ...rowdata,
                toolTypeId: value.toolTypeId,
                toolType: value.toolType,
              },
            })
          );
        } else if (tagType === "countryToolResidesIn") {
          dispatch(
            submitDataAction({
              body: {
                ...rowdata,
                countryToolResidesIn: value.countryToolResidesIn,
                countryToolResidesInName: value.countryToolResidesInName,
                stateToolResidesIn: null,
                stateToolResidesInName: null,
              },
            })
          );
        } else if (tagType === "stateToolResidesIn") {
          dispatch(
            submitDataAction({
              body: {
                ...rowdata,
                stateToolResidesIn: value.stateToolResidesIn,
                stateToolResidesInName: value.stateToolResidesInName,
              },
            })
          );
        } else if (tagType === "toolNumber") {
          console.log("toolNumberxx", {
            bindingData,
          });
          newBindingData?.toolNumber && dispatch(
            submitDataAction({
              body: {
                ...rowdata,
                ...(newBindingData ?? {}),
              },
            })
          );
        } else
          if (tagType === "toolNumberStatic") {
            dispatch(
              submitDataAction({
                body: {
                  ...rowdata,
                  toolNumber: value[0],
                  toolDescription: value[1],
                },
              })
            );
          } else if (tagType === "toolNumberWrite") {
            dispatch(
              submitDataAction({
                body: {
                  ...rowdata,
                  toolNumber: value,
                },
              })
            );
          } else if (tagType === "toolDescription") {
            dispatch(
              submitDataAction({
                body: {
                  ...rowdata,
                  toolDescription: value,
                },
              })
            );
          } else {
            dispatch(
              submitDataAction({
                body: {
                  ...rowdata,
                  [tagType]: value,
                },
              })
            );
          }
      };
  const handleToolNumberWrite = createTagHandler("toolNumberWrite");
  const handleToolNumber = createTagHandler("toolNumber");
  const handleToolNumberStatic = createTagHandler("toolNumberStatic");
  const handleToolDescriptionStatic = createTagHandler("toolDescription");

  const handleSupplierName = createTagHandler("supplierName");
  const handleToolTypeId = createTagHandler("toolTypeId");
  const handlePoNumber = createTagHandler("poNumber");
  const handleProductLines = createTagHandler("productLines");
  const handleModelYearMin = createTagHandler("modelYearMin");
  const handleModelYearMax = createTagHandler("modelYearMax");
  const handleCountryToolResidesIn = createTagHandler("countryToolResidesIn");
  const handleTotalPOValue = createTagHandler("totalPOValue");
  const handleProjectNumber = createTagHandler("projectNumber");
  const handlelastUsedDate = createTagHandler("lastUsedDate");
  const handleStateToolResidesIn = createTagHandler("stateToolResidesIn");
  //  const handleCountryToolResidesInName = createTagHandler(
  //   "countryToolResidesInName"
  // );
  const lastUsedDate = row.lastUsedDate;
  const lastUsedDateFormatted = lastUsedDate ? moment(lastUsedDate)
    .utc()
    .format("YYYY-MM-DD") : '';

  useEffect(() => {
    if (row && row.requester && countriesValue.length > 0) {
      let country = countriesValue.filter((item) => {
        return item.code === row.countryToolResidesIn;
      });

      let conName = country && country[0] && country[0].name;
      //handleCountryToolResidesInName(conName);
    }
  }, [row.countryToolResidesIn, countriesValue]);

  useEffect(() => {
    handleCountryChange(row.countryToolResidesIn);
  }, [row.countryToolResidesIn]);

  useEffect(() => {
    if (row?.toolNumber && toolSelectOption.toLowerCase() !== "write-in") {
      setToolSelectOption("notSelected"); 
    } 
  }, [row.toolNumber]); 

  useEffect(() => {
    if (
      toolTypesValue &&
      toolTypesValue.length > 0 &&
      row &&
      row.toolTypeId != undefined &&
      row.countryToolResidesInName
    ) {
      let tool = toolTypesValue.filter((item) => {
        return item.id === row.toolTypeId;
      });
      let tooObj = {
        toolType: tool[0].description,
        toolTypeId: tool[0].id,
      };
      handleToolTypeId(tooObj);
    }
  }, [toolTypesValue, row.toolTypeId, row.countryToolResidesInName]);

  const stateUseEffect = () => {
    let state = stateToolResidesInUpdated.filter((item) => {
      return item.stateToolResidesIn === row.stateToolResidesIn;
    });
    //state.length > 0 && handleStateToolResidesIn(state[0]);
  };
  function handleCountryChange(value: any) {
    dispatch(getNewRequest_stateAction(value));
  }

  const [supplierNumderAddPart, setSupplierNumderAddPart] = React.useState({
    supplierName: null,
    supplierNumber: null,
  });
  let supplierNumber =
    supplierNumderAddPart && supplierNumderAddPart.supplierNumber;
  const [toolSelectOption, setToolSelectOption] = useState("notSelected");

  const handleOpen = () => {
    const { ...rowdata } = row;

    dispatch(
      submitDataAction({
        body: {
          ...rowdata,
          ...{
            id: undefined,
            supplierName: undefined,
            supplierNumber: undefined,
            poNumber: undefined,
            productLines: undefined,
            countryToolResidesIn: undefined,
            stateToolResidesIn: undefined,
            toolTypeId: undefined,
            toolType: undefined,
            totalPOValue: undefined,
            projectNumber: undefined,
            toolNumber: undefined,
            toolDescription: undefined,
            lastUsedDate: undefined,
            modelYearMax: undefined,
            modelYearMin: undefined,
          }
        }
      })
    );
    setOpen(true);
  };

  const handleClose = () => {
    onaHandleClose();
    setOpen(false);
  };
  const onConfirm = () => {
    
    if (row.toolNumber.toLowerCase() !== 'no tool number') {
      const isDuplicate = toolsDetailRows.some(r => r.toolNumber === row.toolNumber && r.id !== row.id); // Check for duplicates in different rows
      if (isDuplicate) {
        setWarningMessage('This tool number already exists in the list. Please add a different tool.');
        return;
      }
    }
    if (!row.toolDescription) {
      setWarningMessage('Tool Description can not be empty or null. Please fill the required field and try again.')
     return;
    }
    onConfirmClick();
    handleClose();
  };

  const handleSupplierDebounce = debounce((value) => {
    value.length > 2 && dispatch(getNewRequest_suppliersAction(value));
  }, 1000);

  const handlePartNumberDebounce = debounce((supplierNumber, value) => {
    value.length > 2 &&
      dispatch(
        getNewRequest_itemsAction([
          { supplierNumber: supplierNumber, itemNumber: value },
        ])
      );
  }, 1000);
  const handleToolDebounce = debounce((value) => {
    value.length > 2 && dispatch(getNewRequest_toolAction(value));
  }, 1000);
  useEffect(() => {
    if (row.supplierNumber != undefined) {
      let supplierNumderAddPartObj: any = {
        supplierName: row.supplierName,
        supplierNumber: row.supplierNumber,
      };
      setSupplierNumderAddPart(supplierNumderAddPartObj);
    }
  }, [row]);
  const stateToolResidesInUpdated = statesValue.map((object) => {
    return {
      stateToolResidesIn: object.code,
      stateToolResidesInName: object.name,
    };
  });
  const productLineseUpdated = productLinese.map((object) => {
    return {
      ...object,
      productLines: object.name,
    };
  });
  const countriesValueUpdated = countriesValue.map((object) => {
    return {
      ...object,
      countryToolResidesIn: object.code,
      countryToolResidesInName: object.name,
    };
  });
  const updatedTool = toolTypesValue.map((object) => {
    return {
      toolType: object.description,
      toolTypeId: object.id,
    };
  });
  const projectNumberUpdated = projectNumberValue.map((object) => {
    return {
      ...object,
      projectNumber: object.number,
    };
  });
  const merge = (...arrays) => {
    const merged = {};

    arrays.forEach((data) =>
      data.forEach((o) => Object.assign((merged[o.supplierNumber] ??= {}), o))
    );

    return Object.values(merged);
  };
  let totalSupplierData = merge(supplierNumberValue, supplierValue);
  function handleFilterChange(options: any) {
    let newToolValuFiltered = toolValue.filter((obj) => {
      return obj.toolNumber === options.toolNumber;
    });
    let data = newToolValuFiltered[0];

    let newToolBindingData = {
      supplierName: data.vendorName,
      supplierNumber: data.vendorNo,
      poNumber: data.toolValue.value,
      productLines: data.productGroup,
      countryToolResidesIn: data.toolLocation.country,
      stateToolResidesIn: data.toolLocation.state,
      toolTypeId: data.toolTypeId,
      toolType: data.toolType,
      totalPOValue: data.toolValue.poActualAmount,
      projectNumber: data.projectNumber,
      toolNumber: data.toolNumber,
      toolDescription: data.toolDescription,
    };

    setBindingData(newToolBindingData);
    return newToolBindingData;
  }

  console.log("validationStatus", row);
  return (
    <>
      <div>
        <Button
          className={classes.button1}
          data-tut={"reactour__addTool"}
          variant="contained"
          color="primary"
          disabled={disabled}
          onClick={handleOpen}
          startIcon={<AddIcon />}
        >
          Add Tool
        </Button>

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Card className={classes.root}>
              <CardContent>
                <Box mb={2}>
                  <Typography variant="h5" component="h2">
                    Add Tool
                  </Typography>
                </Box>
                <Box data-tut={"reactour__toolInformation"}>

                  <Grid container direction={"row"} spacing={2}>
                    <Grid item xs={12} md={6} lg={6}>
                      <Grid container direction={"column"} spacing={2}>
                        <Grid item>
                          <Autocomplete
                            id="tool-option-select"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            clearOnBlur
                            aria-label={"tool-option-select"}
                            fullWidth
                            options={toolSelectOptions}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="Tool Select Option"
                                variant="outlined"
                                className={classes.textField}
                              />
                            )}
                            onChange={(event, options) => {
                              if (!options) {
                                return;
                              } else if (options === "No tool Number") {
                                handleToolNumberStatic([
                                  "No tool Number",
                                  "No tool description",
                                ]);
                              } else {
                                handleToolNumberStatic([null, null]);
                              }
                              setToolSelectOption(options);
                            }}
                          />
                        </Grid>
                        {toolSelectOption === "Write-In" ? (
                          <>
                            <Grid item>
                              <TextField
                                fullWidth
                                disabled={
                                  paramsData.disposalStatusId === "2" ||
                                    paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4" ||
                                    (!requester &&
                                      (paramsData.disposalStatusId === "3" ||
                                        paramsData.disposalStatusId === "4"))
                                    ? true
                                    : false
                                }
                                value={
                                  row.toolNumber === null || row.toolNumber === undefined
                                    ? ""
                                    : row.toolNumber
                                }
                                required
                                label="Tool Number"
                                variant="outlined"
                                className={classes.textField}
                                onChange={(event) =>
                                  handleToolNumberWrite(event.target.value as string)
                                }
                              />
                            </Grid>
                            <Grid item>
                              <TextField
                                fullWidth
                                disabled={
                                  paramsData.disposalStatusId === "2" ||
                                    paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4" ||
                                    (!requester &&
                                      (paramsData.disposalStatusId === "3" ||
                                        paramsData.disposalStatusId === "4"))
                                    ? true
                                    : false
                                }
                                value={
                                  row.toolNumber === null || row.toolNumber === undefined
                                    ? ""
                                    : row.toolDescription
                                }
                                error={
                                  validationStatus && !row?.toolDescription
                                }
                                required
                                label="Tool Description"
                                variant="outlined"
                                className={classes.textField}
                                onChange={(event) =>
                                  handleToolDescriptionStatic(event.target.value as string)
                                }
                              />
                            </Grid>
                          </>
                        ) : toolSelectOption === "No tool Number" ? (
                          <>
                            <Grid item>
                              <TextField
                                fullWidth
                                disabled={
                                  paramsData.disposalStatusId === "2" ||
                                    paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4" ||
                                    (!requester &&
                                      (paramsData.disposalStatusId === "3" ||
                                        paramsData.disposalStatusId === "4"))
                                    ? true
                                    : false
                                }
                                required
                                value="No tool Number"
                                label="Tool Number"
                                variant="outlined"
                                className={classes.textField}
                              />
                            </Grid>
                            <Grid item>
                              <TextField
                                fullWidth
                                disabled={
                                  paramsData.disposalStatusId === "2" ||
                                    paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4" ||
                                    (!requester &&
                                      (paramsData.disposalStatusId === "3" ||
                                        paramsData.disposalStatusId === "4"))
                                    ? true
                                    : false
                                }
                                required
                                error={
                                  validationStatus && !row?.toolDescription
                                }
                                value="No tool Description"
                                label="Tool Description"
                                variant="outlined"
                                className={classes.textField}
                              />
                            </Grid>
                          </>
                        ) : (
                          <Grid item>
                            <Autocomplete
                              id="tool-number-description-select"
                              disabled={
                                paramsData.disposalStatusId === "2" ||
                                  paramsData.disposalStatusId === "3" ||
                                  paramsData.disposalStatusId === "4" ||
                                  (!requester &&
                                    (paramsData.disposalStatusId === "3" ||
                                      paramsData.disposalStatusId === "4")) ||
                                  (toolSelectOption === "notSelected" &&
                                    paramsData.disposalStatusId === "")
                                  ? true
                                  : false
                              }
                              clearOnBlur
                              value={row}
                              aria-label={"tool-number-description-select"}
                              fullWidth
                              options={toolValue}
                              getOptionLabel={(option: any) =>
                                option.toolNumber != null
                                  ? `${option.toolNumber + " - " + option.toolDescription}`
                                  : ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  label="Tool Number - Description "
                                  variant="outlined"
                                  className={classes.textField}
                                // error={
                                //   validationStatus && (!row?.toolNumber || !row.toolDescription)
                                // }
                                />
                              )}
                              onChange={(event, options) => {
                                if (!options) {
                                  return;
                                }
                                newBindingData = handleFilterChange(options);
                                handleToolNumber(options);
                              }}
                              onInputChange={(event, value) => {
                                if (!value) {
                                  return;
                                }
                                handleToolDebounce(value);
                              }}
                            />
                          </Grid>
                        )}
                        <Grid item>
                          <Autocomplete
                            id="supplier-number-select"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            filterSelectedOptions
                            value={row}
                            clearOnBlur
                            fullWidth
                            options={totalSupplierData.map((option) => option)}
                            getOptionLabel={(option: any) =>
                              option.supplierName != null
                                ? `${option.supplierNumber + " - " + option.supplierName}`
                                : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="Supplier Number / Name"
                                variant="outlined"
                                className={classes.textField}
                              />
                            )}
                            onChange={(event, option) => {
                              handleSupplierName(option as string);
                            }}
                            onInputChange={(event, value) => {
                              if (!value) {
                                return;
                              }
                              handleSupplierDebounce(value);
                            }}
                          />
                        </Grid>

                        <Grid item>
                          <TextField
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            fullWidth
                            value={
                              row.poNumber === null || row.poNumber === undefined
                                ? ""
                                : row.poNumber
                            }
                            required
                            label="Original PO Number"
                            variant="outlined"
                            className={classes.textField}
                            onChange={(event) => handlePoNumber(event.target.value)}
                          />
                        </Grid>

                        <Grid item>
                          <Autocomplete
                            id="product-lines-select"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            value={row}
                            clearOnBlur
                            aria-label={"product-lines-select"}
                            fullWidth
                            options={productLineseUpdated.map((option) => option)}
                            getOptionLabel={(option: any) => option.productLines}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="Product Lines"
                                variant="outlined"
                                className={classes.textField}
                              />
                            )}
                            onChange={(event, options) => {
                              handleProductLines(options.productLines);
                            }}
                          />
                        </Grid>

                        <Grid item>
                          <Grid container direction={"row"} spacing={1}>
                            <Grid item xs={12} md={6} lg={6}>
                              <Autocomplete
                                id="model-year-min-select"
                                value={row}
                                disabled={
                                  paramsData.disposalStatusId === "2" ||
                                    paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4" ||
                                    (!requester &&
                                      (paramsData.disposalStatusId === "3" ||
                                        paramsData.disposalStatusId === "4"))
                                    ? true
                                    : false
                                }
                                clearOnBlur
                                aria-label={"model-year-min-select"}
                                fullWidth
                                options={modelYearMin_data}
                                getOptionLabel={(option: any) => option.modelYearMin}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    label="Model Year - Min"
                                    variant="outlined"
                                    className={classes.textField}
                                  />
                                )}
                                onChange={(event, options) => {
                                  if (!options) {
                                    return;
                                  }
                                  handleModelYearMin(options.modelYearMin as string);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <Autocomplete
                                id="model-year-max-select"
                                disabled={
                                  paramsData.disposalStatusId === "2" ||
                                    paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4" ||
                                    (!requester &&
                                      (paramsData.disposalStatusId === "3" ||
                                        paramsData.disposalStatusId === "4"))
                                    ? true
                                    : false
                                }
                                value={row}
                                clearOnBlur
                                aria-label={"model-year-max-select"}
                                fullWidth
                                options={modelYearMax_data}
                                getOptionLabel={(option: any) => option.modelYearMax}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    label="Model Year - Max"
                                    variant="outlined"
                                    className={classes.textField}
                                  />
                                )}
                                onChange={(event, options) => {
                                  if (!options) {
                                    return;
                                  }
                                  handleModelYearMax(options.modelYearMax as string);
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <Grid container direction={"column"} spacing={2}>
                        <Grid item>
                          <Autocomplete
                            id="tool-type-select"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            clearOnBlur
                            value={updatedTool.find(option => option.toolTypeId === row.toolTypeId) || null}
                            aria-label={"tool-type-select"}
                            fullWidth
                            options={updatedTool}
                            getOptionLabel={(option: any) => option.toolType}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="Tool Type"
                                variant="outlined"
                                className={classes.textField}
                              />
                            )}
                            onChange={(event, options: any) => {
                              if (!options) {
                                return;
                              }
                              handleToolTypeId(options);
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <TextField
                            type="number"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            fullWidth
                            value={
                              row.totalPOValue === null || row.totalPOValue === undefined
                                ? ""
                                : row.totalPOValue
                            }
                            required
                            label="Total Tool Value"
                            variant="outlined"
                            className={classes.textField}
                            onChange={(event) => handleTotalPOValue(event.target.value)}
                          />
                        </Grid>
                        <Grid item>
                          <Autocomplete
                            id="project-number-select"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            value={
                              row.projectNumber === null ||
                                row.projectNumber === undefined
                                ? ""
                                : row
                            }
                            clearOnBlur
                            aria-label={"project-number-select"}
                            fullWidth
                            options={projectNumberUpdated.map((option) => option)}
                            getOptionLabel={(option: any) => option.projectNumber}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="Project Number"
                                variant="outlined"
                                className={classes.textField}
                              />
                            )}
                            onChange={(event, options) => {
                              if (!options) {
                                return;
                              }
                              handleProjectNumber(options.number);
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <TextField
                            id="date"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            label="Last Date Used"
                            type="date"
                            value={lastUsedDateFormatted}
                            required
                            fullWidth
                            variant="outlined"
                            className={classes.textField}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(event) => {
                              const date = new Date(event.target.value);
                              if (isNaN(date.getTime())) {
                                handlelastUsedDate("");
                              } else {
                                handlelastUsedDate(date as unknown as string);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <Autocomplete
                            id="country-tool-resides-in-select"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            value={countriesValueUpdated.find(option => option.countryToolResidesIn === row.countryToolResidesIn) || null}
                            clearOnBlur
                            aria-label={"country-tool-resides-in-select"}
                            fullWidth
                            options={countriesValueUpdated.map((option: { countryToolResidesIn: string; countryToolResidesInName: string }) => option)}
                            getOptionLabel={(option: any) =>
                              option.countryToolResidesIn &&
                                option.countryToolResidesInName != undefined
                                ? `${option.countryToolResidesInName} (${option.countryToolResidesIn}) `
                                : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="Country Tool Resides In"
                                variant="outlined"
                                className={classes.textField}
                              />
                            )}
                            onChange={(event, options) => {
                              if (!options) {
                                return;
                              }
                              handleCountryToolResidesIn(options);
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <Autocomplete
                            id="state-tool-resides-in-select"
                            disabled={
                              paramsData.disposalStatusId === "2" ||
                                paramsData.disposalStatusId === "3" ||
                                paramsData.disposalStatusId === "4" ||
                                (!requester &&
                                  (paramsData.disposalStatusId === "3" ||
                                    paramsData.disposalStatusId === "4"))
                                ? true
                                : false
                            }
                            value={stateToolResidesInUpdated.find(option => option.stateToolResidesIn === row.stateToolResidesIn) || null}
                            clearOnBlur
                            aria-label={"state-tool-resides-in-select"}
                            fullWidth
                            options={stateToolResidesInUpdated.map((option) => option)}
                            getOptionLabel={(option: any) =>
                              option.stateToolResidesIn != null
                                ? `${option.stateToolResidesInName +
                                " " +
                                "(" +
                                option.stateToolResidesIn +
                                ")"
                                }`
                                : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="State Tool Resides In"
                                variant="outlined"
                                className={classes.textField}
                              />
                            )}
                            onChange={(event, options) => {
                              if (!options) {
                                return;
                              }
                              handleStateToolResidesIn(options);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>{" "}
                </Box>
                <Box my={2}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Button
                      className={classes.button}
                      data-tut={"reactour__download-Button"}
                      variant="contained"
                      color="primary"
                      disabled={
                        (row.toolNumber && row.toolType && row.supplierNumber && row.poNumber && row.productLines && row.countryToolResidesIn && row.stateToolResidesIn && row.totalPOValue
                          && row.projectNumber && row.modelYearMin && row.modelYearMax && row.lastUsedDate) ? false : true
                      }
                      onClick={onConfirm}
                    >
                      CONFIRM
                    </Button>
                    <Button
                      className={classes.button}
                      data-tut={"reactour__download-Button"}
                      variant="outlined"
                      color="primary"
                      disabled={false}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Fade>
        </Modal>
      </div>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    root: {
      minWidth: 900,
      padding: 12,
    },

    button: {
      minWidth: "7.188rem",
    },

    textField: {
      "& .MuiFormLabel-root": {
        color: "inherit",
      },
    },
    button1: {
      width: "100%",
      justifyContent: "left",
      background: "#EBF1F7",
      color: "black",
      border: 0,
      borderRadius: 0,
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#ffffff",
        color: "#004e97",
        boxShadow: "none",
      },
    },
  })
);
function setWarningMessage(message: string) {
  if (message) { // Check if message is not empty
    toast.warn(message, {
      position: toast.POSITION.TOP_CENTER, // Set position for better visibility
      autoClose: 5000, // Auto close after 5 seconds
      hideProgressBar: false, // Show progress bar
      closeOnClick: true, // Allow closing on click
      pauseOnHover: true, // Pause on hover
      draggable: true, // Allow dragging
      progress: undefined, // Default progress
    });
  }
}